export const primaryColor = '#f98d00';

export const centered = `
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;